module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-sleepy.34a1dc2a.png";